import { CitesType } from 'types/global';
import { citySize, mapSizeX } from 'constant/env';
import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext, useEffect, useRef, useState } from 'react';
import { Image } from '@react-three/drei';
import Plus from 'assets/img/plus.png';
import gsap from 'gsap';
type Props = {
  index?: number;
  data: CitesType;
  setData: React.Dispatch<React.SetStateAction<CitesType>>;
};

function ExpandButton({ index = 0, data, setData }: Props) {
  const { setCurrentIndex, navIndex } = useContext(ControlContext);
  const ExpandCity = () => {
    let btns = data.expandBtns;
    btns = [...btns, index + 1, index - 1, index + mapSizeX, index - mapSizeX];
    let uniqueBtns = btns.filter((value, sindex) => {
      return btns.indexOf(value) === sindex;
    });
    [...data.cities, index].forEach((ele) => {
      uniqueBtns = uniqueBtns.filter((value) => value !== ele);
    });
    setCurrentIndex(index);
    setData({
      cities: [...data.cities, index],
      expandBtns: uniqueBtns,
    });
  };
  const [hovered, setHover] = useState<boolean>(false);
  const meshRef = useRef<any>(null);
  useEffect(() => {
    if (hovered && navIndex === 0) hoverScale();
    else if (!hovered && meshRef.current) scaleUp();
  }, [hovered]);
  useEffect(() => {
    if (meshRef.current) scaleUp();
  }, [meshRef]);
  useEffect(() => {
    if (meshRef.current) {
      if (navIndex === 0) scaleUp();
      else scaleDown();
    }
  }, [navIndex]);
  const hoverScale = () => {
    gsap.to(meshRef.current.scale, {
      x: 1.5,
      y: 1,
      z: 1.5,
      duration: 0.5,
      ease: 'poweer2.out',
    });
  };
  const scaleUp = () => {
    gsap.to(meshRef.current.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 1,
      ease: 'poweer2.out',
    });
  };
  const scaleDown = () => {
    gsap.to(meshRef.current.scale, {
      x: 0,
      y: 0,
      z: 0,
      duration: 1,
      ease: 'poweer2.out',
    });
  };
  return (
    <group
      ref={meshRef}
      position={[
        (index % mapSizeX) * citySize,
        0,
        Math.floor(index / mapSizeX) * citySize,
      ]}
      onClick={(e) => {
        e.stopPropagation();
        ExpandCity();
      }}
      onPointerOver={(e) => {
        e.stopPropagation();
        setHover(true);
      }}
      onPointerOut={() => setHover(false)}
      scale={[0.1, 0.1, 0.1]}
    >
      <Image
        url={Plus}
        scale={citySize / 3}
        transparent
        rotation={[-Math.PI / 2, 0, 0]}
      />
    </group>
  );
}

export default memo(ExpandButton);
